<div *ngIf="vwo.ticker_otd_AB() && this.vars?.pageName?.match('stories|campaign') && !params?.mini_story && params?.payment !== 'options' " class="ticker" [ngClass]="{'hide-ticker': hideTicker, 'story-ticker': vars?.pageName?.match('stories') && !isMobile}">
  <app-module-loader moduleId="ticker-otd" selector="app-ticker-otd" [load]="true" [outputs]="{showTicker: showTicker}">
  </app-module-loader>
</div>
<button [ngClass]="btnClass" [disabled]="getButtonState()" (click)="onClickListner.next($event)" mat-raised-button>
  <div class="content" *ngIf="!isOrderLoading && !isSipCause && !payment_config?.is_sip">
    <span [innerHTML]="label"></span>&nbsp;
    <app-currency-icon *ngIf="currency && amount && !hideAmount" [currency]="currency"></app-currency-icon>
    <span *ngIf="amount && !hideAmount">&nbsp;{{amount}} </span>
    <!-- <span *ngIf="type=='recuring' && !hideAmount">/ Month</span> -->
    <span *ngIf="type=='recuring' && !hideAmount && !actRoute?.snapshot?.queryParams?.auto_pay_m1">/ {{(month_interval && month_interval>1) ? month_interval+' Months' : 'Month'}}</span>
    <span *ngIf="type=='recuring' && !hideAmount && actRoute?.snapshot?.queryParams?.auto_pay_m1"> from next month</span>
  </div>
  <div class="content" *ngIf="!isOrderLoading && isSipCause && !payment_config?.is_sip">
    <span>Pledge</span>&nbsp;
    <app-currency-icon *ngIf="currency && amount && !hideAmount" [currency]="currency"></app-currency-icon>
    <span>&nbsp;{{amount}}/Month </span><span *ngIf="!ngo_Sip" class="extra-text">for 6 months</span>
  </div>
  <div class="content" *ngIf="!isOrderLoading && payment_config?.is_sip">
    <div>Proceed to Payment</div>
  </div>
  <div *ngIf="isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>
